export default __webpack_public_path__ + "static/media/Helm of the Proven Champion.785da562.jpg";